// x-default 日本語のみの場合 WOVN出力によるx-defaultの値を日本語のURLに
const isApiTimeout = 1000;
let isApiReady = false;
let apiTimeout;

// wovnApiReadyが呼ばれなかった場合の処理
$(window).on("load", function () {
  apiTimeout = setTimeout(function () {
    if (!isApiReady) {
      $('link[rel="alternate"][hreflang="x-default"]').attr("href", location.href);
    }
  }, isApiTimeout);
});

window.addEventListener("wovnApiReady", function (evt) {
  isApiReady = true;
  clearTimeout(apiTimeout);
  if (!WOVN.io.isPublished("en")) {
    $('link[rel="alternate"][hreflang="x-default"]').attr("href", location.href);
  }
});

// Gナビスクロールアクション
$(function () {
  let currentPositon = 0;
  let startPosition = $(window).scrollTop();
  const headerFix = $(".l-header__fix");

  $(window).on("scroll", function (e) {
    currentPositon = $(this).scrollTop();
    if (headerFix.height() > currentPositon) {
      headerFix.removeClass("hideHeaderFix");
      return;
    }

    if (currentPositon > startPosition) {
      // 下スクロール
      if (!headerFix.hasClass("hideHeaderFix")) headerFix.addClass("hideHeaderFix");
    } else {
      // 上スクロール
      headerFix.removeClass("hideHeaderFix");
    }
    startPosition = currentPositon;
  });
});

//1350px以上全体ズーム
$(function () {
  const $mainInner = $(".l-main__inner");

  if ($mainInner[0]) {
    const $main = $(".l-main");
    const $notTar = $(".home-kv, .p-bread");

    $notTar.each(function (index, el) {
      $(this).attr("data-margin-b", $(this).css("margin-bottom"));
    });

    $(window).on("resize", function (event) {
      //    runZoom();
    });

    function runZoom() {
      const winW = $(window).innerWidth();
      const startW = 1350; //デザイン幅
      const maxW = 1920; //最大幅
      const maxWZoom = 0.25; //最大幅の時にプラスする拡大率

      if (winW > startW) {
        let per = (winW - startW) / (maxW - startW);
        let zoom = maxWZoom * per + 1;

        let h = $mainInner.innerHeight() * zoom;

        $main.css({
          transform: "scale(" + zoom + ")",
          "transform-origin": "center top",
          height: h,
        });

        //拡大しない要素
        $notTar.each(function (index, el) {
          if ($(this).hasClass("home-kv")) {
            if ($(this).find(".slick-initialized")[0]) {
              $(this).removeClass("is-hide");
            } else {
              $(this).addClass("is-hide");
              return false;
            }
          }
          let mb = parseInt($(this).attr("data-margin-b"));
          mb -= $(this).innerHeight() * (zoom - 1);

          $(this).css({
            transform: "scale(" + 1 / zoom + ")",
            "transform-origin": "center top",
            "margin-bottom": mb,
          });
        });
      } else {
        $main.removeAttr("style");
        $notTar.removeAttr("style");
      }
    }
  }
});

const urlPath = location.pathname;
const urlHash = location.hash;

// aタグ スムーススクロール
$(function () {
  //技術情報 別ページからのスクロール調整
  if (urlPath == "/technology/") {
    //技術情報内のページスクロール ハッシュのみに書き換え
    $("a.techinfo").each(function (index, el) {
      var replaceTxt = null;
      replaceTxt = $(this)
        .attr("href")
        .replace(/\/technology\//g, "");
      $(this).attr("href", replaceTxt);
    });
    //スマートフォンのメニュークローズ処理
    $("a.techinfo").click(function () {
      if ($(".p-hd__spMenu a").hasClass("is-on")) {
        $(".p-hd__spMenu a").toggleClass("is-on");
        $(".p-spNav").stop().slideToggle(300);
      }
    });
  }

  $("body").on("click", 'a[href^="#"]', function () {
    const that = this;
    const speed = 500;
    const href = $(this).attr("href");
    const target = $(href === "#" || href === "" ? "html" : href);

    if (!target.length) return false;

    const getAdjustedPosition = () => {
      let pos = target.offset().top;
      const fixedBlockSelector = $(that).data("fixedblock");
      if (fixedBlockSelector) {
        fixedBlockSelector.split(" ").forEach(function (selector) {
          const fixedBlock = $(selector);
          if (fixedBlock.length > 0) {
            pos -= fixedBlock.outerHeight();
          }
        });
      } else {
        pos -= $(".l-header").outerHeight();
      }
      return pos;
    };

    if ($(that).hasClass("tech-info")) {
      $("body,html").stop().scrollTop(0);
      return false;
    }

    $("html, body").animate({ scrollTop: getAdjustedPosition() }, speed, "swing", function () {
      setTimeout(function () {
        $("body,html").stop();

        if ($(window).scrollTop() > $(".l-header").height()) {
          $(".l-header__fix").addClass("hideHeaderFix");
        }

        // 現在位置と目標位置のズレが大きければ再調整
        const finalPos = getAdjustedPosition();
        const currentPos = $(window).scrollTop();
        if (Math.abs(currentPos - finalPos) > 5) {
          $("html, body").animate({ scrollTop: finalPos }, 50);
        }
      }, 0);

      const callback = window[$(that).data("scroll-callback")];
      if (typeof callback === "function") {
        callback(that);
      }
    });

    return false;
  });
});

// ハッシュ付きリンクで遷移した際のスクロール位置調節
if (urlHash && $(urlHash).length > 0) {
  // 仮のaタグを生成して、aタグに設定されているスムーススクロールを実行すさせる
  let aTag = $("<a>", {
    href: urlHash,
    css: {
      position: "fixed",
      top: "0",
      left: "0",
      opacity: "0",
      zIndex: 0,
    },
  });
  $("body").append(aTag);

  $(function () {
    setTimeout(function () {
      aTag.trigger("click");
      aTag.remove();
    }, 20);
  });
}

$(function () {
  const $bar = $("#wpadminbar");

  if ($bar[0]) {
    let isSc = false;

    $(window).on("load scroll", function (event) {
      if ($(window).scrollTop() > 10) {
        if (!isSc) {
          isSc = true;

          $bar.hide();
        }
      } else {
        if (isSc) {
          isSc = false;

          $bar.show();
        }
      }
    });
  }
});

$(function () {
  $("table").each(function (index, el) {
    $(this).wrap('<div class="tableScroll"></div>');
  });
});

$(function () {
  const root = $(".productsDetail-spNav");

  if (root[0]) {
    const btn = $(".js-productsDetailSpNavBtn");
    const list1 = $(".productsDetail-spNav__list.-num1");
    const list2 = $(".productsDetail-spNav__list.-num2");
    const link = $(".js-productsDetailSpNavLink");
    let isShow = false;

    btn.click(function (event) {
      if (!isShow) {
        isShow = true;

        list2.stop().css("opacity", 0).slideDown(300);
        setTimeout(function () {
          list1.addClass("is-hide");
          list2.css("opacity", 1);
        }, 70);
      } else {
        isShow = false;

        list1.removeClass("is-hide");
        list2.stop().slideUp(300);
      }
    });

    link.click(function (event) {
      isShow = false;

      list1.removeClass("is-hide");
      list2.stop().slideUp(300);
    });
  }
});

$(function () {
  const $openArea = $(".js-openHdChild");

  if ($openArea[0]) {
    const $child = $(".p-hdChild");
    let timerID = null;

    $openArea.each(function (index, el) {
      const t = $(this);
      const templateName = t.data("template");
      const target = $child.filter('[data-template="' + templateName + '"]');

      t.hover(
        function (e) {
          if (timerID) {
            clearTimeout(timerID);
          }
          $child.removeClass("is-show");
          target.addClass("is-show");
        },
        function (e) {
          timerID = setTimeout(function () {
            target.removeClass("is-show");
          }, 200);
        }
      );
    });

    function childPos() {
      $openArea.each(function (index, el) {
        let l = $(this).offset().left + $(this).innerWidth() / 2;
        $child.eq(index).css("left", l);
      });
    }
  }
});

$(function () {
  const $parent = $(".p-spNav__nav a.-parent");

  if ($parent[0]) {
    $parent.click(function (event) {
      const openMenu = $(".p-spNav__nav a.-parent.is-on");
      // 開いているメニューがクリックされたメニューではない
      // クリックされたメニューが開いているメニューの子要素ではない
      // → 開いているメニューを閉じる処理を実行
      if (openMenu.length > 0 && !$(this).is(openMenu) && openMenu.next().find(this).length == 0) {
        openMenu.removeClass("is-on").next("ul").stop().slideUp(300);
      }
      $(this).toggleClass("is-on").next("ul").stop().slideToggle(300);
    });
  }
});

$(function () {
  const $menu = $(".p-hd__spMenu a");

  if ($menu[0]) {
    $menu.click(function (event) {
      $(this).toggleClass("is-on");
      $(".p-spNav").stop().slideToggle(300);
    });
  }

  // GナビのメニューをクリックしたらGナビを閉じる
  $(".p-spNav__nav a:not(.-parent)").on("click", function () {
    $(".p-hd__spMenu a.is-on").trigger("click");
  });
});

$(function () {
  const $slider = $(".home-kv__slider");

  if ($slider[0]) {
    $slider.slick({
      waitForAnimate: false,
      autoplay: true,
      autoplaySpeed: 6000,
      speed: 1500,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
      arrows: false,
      asNavFor: ".co-menus", // メイン画像と同期
    });
  }
});

$(function () {
  const $slider = $(".co-menus");
  if ($slider[0]) {
    $slider.slick({
      waitForAnimate: false,
      arrows: false,
      slidesToShow: 5, // サムネイルの表示数
      asNavFor: ".home-kv__slider", // メイン画像と同期
      focusOnSelect: true, // サムネイルクリックを有効化
    });
  }
});

$(function () {
  $(".home-kv__slideInner").on("click", function (event) {
    $(this).children(".home-kv__slideInfo").children(".c-btn").children("a")[0].click();
  });
});

$(function () {
  const $slider = $(".home-topicsSlider__inner");

  if ($slider[0]) {
    $slider.slick({
      variableWidth: true,
      arrows: false,
      infinite: false,
    });
  }
});

$(function () {
  const $slider = $(".p-bottomBnrs__slider");

  if ($slider[0]) {
    $slider.slick({
      variableWidth: true,
    });
  }
});

$(function () {
  const $slider = $(".columnDetail-moreSlider__inner");

  if ($slider[0]) {
    $slider.slick({
      variableWidth: true,
    });
  }
});

$(function () {
  const $btn = $(".p-pageTtl.-caseHideConBtn .p-pageTtl__txt");

  if ($btn[0]) {
    $btn.on("click", function (event) {
      const $t = $(this);
      const $con = $t.parent().parent().next();

      $t.toggleClass("is-on");
      $con.stop().slideToggle(400);
    });
  }
});

$(function () {
  const $root = $(".productsDetail-grade__hideConBtn");

  if ($root[0]) {
    $root.each(function (index, el) {
      const $btn = $(this);
      const $con = $btn.parent().next(".productsDetail-grade__hideCon");
      const $close = $con.find(".productsDetail-grade__hideConClose");

      $btn.on("click", function (event) {
        const $t = $(this);

        $t.toggleClass("is-on");
        $con.stop().slideToggle(400);
      });

      $close.on("click", function (event) {
        $btn.removeClass("is-on");
        $con.stop().slideUp(400);
      });
    });
  }
});

$(function () {
  const $slider = $(".l-spProductsSlider__inner");

  if ($slider[0]) {
    $slider.slick({
      variableWidth: true,
      centerMode: true,
    });
  }

  const sliderOpt = {
    mobileFirst: true,
    slidesToShow: 1,
    centerMode: true,
    responsive: [
      {
        breakpoint: 990, // 991px 以上
        settings: "unslick",
      },
    ],
  };
  const btProcPostSlider = $(".p-bottomProductsPost-v2__slider");
  if (btProcPostSlider.length > 0) {
    btProcPostSlider.slick(sliderOpt);

    const mediaQuery = window.matchMedia("(max-width: 991px)");
    mediaQuery.addEventListener("change", function (e) {
      if (e.matches && !btProcPostSlider.hasClass("slick-initialized")) {
        btProcPostSlider.slick(sliderOpt);
      }
    });
  }
});

var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var players = [];

function onYouTubeIframeAPIReady() {
  $(".moviePlayerAuto").each(function (index, el) {
    var t = $(this);
    t.attr("data-player-id", players.length);

    var player = new YT.Player(t[0], {
      height: "360",
      width: "640",
      videoId: t.attr("data-video-id"),
      playerVars: {
        modestbranding: 1,
        autohide: 1,
        controls: 0,
        showinfo: 0,
        rel: 0,
        autoplay: 0,
        playsinline: 1,
        loop: 1,
        playlist: t.attr("data-video-id"),
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
    players.push(player);

    function onPlayerStateChange(event) {
      var ytStatus = event.target.getPlayerState();

      // 再生終了したとき
      if (ytStatus == YT.PlayerState.ENDED) {
        event.target.seekTo(0, true); //動画の初めにシーク
        event.target.mute();
        event.target.playVideo();
      }
    }

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
      event.target.mute();
      //event.target.playVideo();
    }

    function playVideo() {
      player.mute();
      player.playVideo();
    }

    function stopVideo() {
      player.stopVideo();
    }
  });

  setTimeout(function () {
    $(".moviePlayerModal").each(function (index, el) {
      var t = $(this);
      t.attr("data-player-id", players.length);

      var player = new YT.Player(t[0], {
        height: "360",
        width: "640",
        videoId: t.attr("data-video-id"),
        playerVars: {
          modestbranding: 1,
          autohide: 1,
          controls: 1,
          showinfo: 0,
          rel: 0,
          autoplay: 0,
          playsinline: 1,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      });
      players.push(player);

      function onPlayerStateChange(event) {
        /*var ytStatus = event.target.getPlayerState();

        // 再生終了したとき
        if (ytStatus == YT.PlayerState.ENDED) {
          player.mute();
          player.playVideo();
        }*/
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        //event.target.mute();
        //event.target.playVideo();
      }

      function playVideo() {
        player.mute();
        player.playVideo();
      }

      function stopVideo() {
        player.stopVideo();
      }
    });

    $(".remodalMovie").each(function (index, el) {
      var t = $(this);

      t.on("opening", function () {});

      t.on("opened", function () {
        var p = players[t.find(".moviePlayerModal").attr("data-player-id")];
        p.playVideo();
      });

      t.on("closing", function (e) {
        var p = players[t.find(".moviePlayerModal").attr("data-player-id")];
        p.stopVideo();
      });

      t.on("closed", function (e) {
        var p = players[t.find(".moviePlayerModal").attr("data-player-id")];
        p.stopVideo();
      });
    });

    $(".remodalMovieFile").each(function (index, el) {
      var t = $(this);

      t.on("opening", function () {});

      t.on("opened", function () {
        var p = t.find("video");
        p.get(0).play();
      });

      t.on("closing", function (e) {
        var p = t.find("video");
        p.get(0).pause();
      });

      t.on("closed", function (e) {
        var p = t.find("video");
        p.get(0).pause();
      });
    });
  }, 100);
}

$(function () {
  const btn = $(".tabnavi_btn");

  if (btn[0]) {
    const con = $(".tabcontents_col");

    btn.eq(0).prop("checked", true);

    btn.on("change", function (event) {
      const t = $(this);

      if (t.prop("checked")) {
        btn.not(t).prop("checked", false);
        con.hide().eq(btn.index(this)).stop().fadeIn();
      }
    });
  }
});

$(function () {
  $(".home-topicsSlider__inner").each(function (index, el) {
    const slide = $(this).find(".home-topicsSlide__inner");

    if (slide[0]) {
      function run() {
        let maxH = 0;

        slide.css({
          height: "auto",
        });

        slide.each(function (index, el) {
          let h = $(this).innerHeight();
          if (maxH < h) maxH = h;
        });

        slide.css({
          height: maxH,
        });
      }
      run();

      setInterval(function () {
        run();
      }, 1000);
    }
  });
});

$(function () {
  $(".l-spProductsSlider").each(function (index, el) {
    const slide = $(this).find(".l-spProductsSlide__inner");

    if (slide[0]) {
      function run() {
        let maxH = 0;

        slide.css({
          height: "auto",
        });

        slide.each(function (index, el) {
          let h = $(this).innerHeight();
          if (maxH < h) maxH = h;
        });

        slide.css({
          height: maxH,
        });
      }
      run();

      setInterval(function () {
        run();
      }, 1000);
    }
  });
});

$(function () {
  // var dataList = [
  //   ["旭化成", "あさひかせい"],
  //   ["ザイロン", "ざいろん"],
  //   ["レオナ", "れおな"],
  //   ["CAE", "しーえーいー"],
  // ];

  let suggestList = [];
  $.ajax({
    type: "GET",
    caches: false,
    url: suggestJsonFile,
    dataType: "json",
  }).done((data) => {
    data.forEach((val) => {
      const entries = Object.entries(val);
      suggestList.push(entries[0]);
    });

    $(".searchform").each(function (index, el) {
      var form = $(this);
      let defSuggestList = [];
      $.each(suggestList.slice(0, 12), (i, value) => {
        defSuggestList.push(value[0]);
      });
      let autocompleteSearch = form.find(".autocompleteSearch");

      autocompleteSearch
        .on("click", (e) => {
          if (autocompleteSearch.hasClass("opened")) return;
          autocompleteSearch.addClass("opened");
        })
        .autocomplete({
          source: function (request, response) {
            if (request.term === "") {
              setTimeout(() => {
                response(defSuggestList);
              }, 750);
            } else {
              var suggests = [];
              var regexp = new RegExp("(" + request.term + ")", "i");

              $.each(suggestList, function (i, values) {
                if (values[0].match(regexp) || (values[1] && values[1].match(regexp))) {
                  suggests.push(values[0]);
                }
              });
              response(suggests);
            }
          },
          // autoFocus: true,
          delay: 300,
          minLength: 0,
          select: function (event, ui) {
            setTimeout(function () {
              form.submit();
            }, 100);
          },
          position: { my: "left top", at: "left bottom", collision: "flipfit" },
        })
        .focus(function () {
          $(this).autocomplete("search", "");
          $(".ui-menu").css("opacity", "1");
        })
        .blur(function () {
          $(".ui-menu").css("opacity", "0");
        });
    });
  });
});

/*
 * Tooltip
 * <span class="js-tooltip" data-word="xxx">xxxxx</span>
 * data-word: word_idを指定
 */
$(function () {
  tippy(".js-tooltip", {
    theme: "default",
    trigger: "click",
    hideOnClick: true,
    allowHTML: true,
    content(reference) {
      const id = reference.getAttribute("data-word");
      const template = document.getElementById(id);
      return template ? template.innerHTML : "該当するデータがありません";
    },
  });
});

// remodal 位置調節
$(function () {
  $(document).on("opening", ".remodal", function () {
    $(".remodal-wrapper").stop().scrollTop(0);
  });
});

// 関連情報をスライダー表示
if ($(".-relatedSlider").length > 0) {
  $(".-relatedSlider").slick({
    lazyLoad: "ondemand",
    variableWidth: true,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 991, //未満
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  });
}

// urlのパラメータが動的に変更された際に、連動して言語切替リンクのパラメータも変更する関数
function updateLanguageParam() {
  $(".h-nav-lang a").each(function () {
    splitted = $(this).attr("href").split("?");
    $(this).attr("href", splitted[0] + window.location.search);
  });
}

// SPパンくず設定（翻訳前にPCのパンくずを利用）
const pcBread = $(".p-bread ul");
const spBread = $(".p-breadSP");
if (pcBread.length > 0) {
  spBread.append(pcBread.clone());
} else {
  spBread.hide();
}

// パンくずの翻訳漏れを確実に防ぐため、言語変更のタイミングで選択言語でSPパンくずを再翻訳
window.addEventListener("wovnLangChanged", function (evt) {
  if (typeof WOVN.io.swap == "function") {
    WOVN.io.swap(spBread[0]);
  }
});
